import { render, staticRenderFns } from "./NavSearchPage.vue?vue&type=template&id=2e980d99"
import script from "./NavSearchPage.vue?vue&type=script&lang=js"
export * from "./NavSearchPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports